import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textLimiter',
})
export class TextLimiterPipe implements PipeTransform {
  transform(value: any, limit: number = 50) {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
}
